export const SEND_TRANSCRIPT_PROMPT = 'sendTranscriptPrompt';
export const BLOCK_THREAD = 'blockThreadPrompt';
export const MOVE_TO_INBOX_PROMPT = 'moveToInboxPrompt';